import React from 'react';
interface FlagProps {
  className?: string;
}

/** Simplified United States flag mark used for the English language toggle. */
export function FlagUS({
  className = ''
}: FlagProps) {
  return <svg viewBox="0 0 32 22" className={className} role="presentation" aria-hidden="true" focusable="false" data-id="element-417" data-mp="39qcd10zbwcvz">
      <rect width="32" height="22" fill="#F5F5F5" data-id="element-418" data-mp="35nzh14advtce" />
      {[0, 2, 4, 6, 8, 10, 12].map(row => <rect key={row} y={row * (22 / 13)} width="32" height={22 / 13} fill="#C8102E" data-id="element-419" data-mp="3jn8lx7t53112" />)}
      <rect width="14" height={22 / 13 * 7} fill="#1A3A52" data-id="element-420" data-mp="3epp8290csq9n" />
      {[0, 1, 2].map(row => [0, 1, 2, 3].map(col => <circle key={`${row}-${col}`} cx={2.4 + col * 3.2} cy={2.2 + row * 3.2} r="0.9" fill="#FFFFFF" data-id="element-421" data-mp="3tda8fv5ugbdv" />))}
    </svg>;
}

/** Simplified Spain flag mark used for the Spanish language toggle. */
export function FlagES({
  className = ''
}: FlagProps) {
  return <svg viewBox="0 0 32 22" className={className} role="presentation" aria-hidden="true" focusable="false" data-id="element-422" data-mp="2ff0idr5ujnjl">
      <rect width="32" height="22" fill="#C60B1E" data-id="element-423" data-mp="2kdbru0s8bw1a" />
      <rect y="5.5" width="32" height="11" fill="#FFC400" data-id="element-424" data-mp="2kfxwnsnqjxft" />
      <rect x="5" y="8.5" width="5" height="5" rx="0.6" fill="#C60B1E" data-id="element-425" data-mp="2pbwq3unx85n3" />
    </svg>;
}